import React from "react";

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Map error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="d-flex flex-column align-items-center justify-content-center p-4 text-center"
          style={{
            height: this.props.height || "300px",
            background: "#f8f9fa",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>🗺️</div>
          <h6 className="fw-bold mb-2">Map could not be loaded</h6>
          <p className="text-muted small mb-0">
            There was a problem loading the map. Please try refreshing the page.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default MapErrorBoundary;